import { SettingsAPI } from '@business/api/settings';
import { SettingsResponse } from '@business/entities/settings';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { SettingsConfig } from '@core/utils/config';
import { Session } from '@modules/auth/session';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap, tap } from 'rxjs/operators';

export class SettingsBloc extends BaseBloc {
  onInit() {
    if (Session.isAuthenticated) {
      this.fetchSettings().subscribe();
    }
  }

  fetchSettings = () => {
    return SettingsAPI.fetchSettings().pipe(
      tap(settings => SettingsConfig.set(settings)),
      handleMessage({ error: requestMessage('fetch_companies_error') }),
    );
  };

  updateInstructorsSettings = (data: Partial<SettingsResponse>) => {
    return SettingsAPI.updateInstructorsSettings(data).pipe(
      tap(settings => SettingsConfig.set(settings)),
      handleMessage({ type: requestMessage('settings_updated') }),
    );
  };
}
